import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchPendingApprovalAPi,
  approveOrRejectFileApi,
  filterFileApprovals,
} from "../../../api/endpoint";

function* getPendingApprovalSaga(action) {
  try {
    const _api = yield call(fetchPendingApprovalAPi, action.payload);
    yield put(actions.setFilesPendingApprovals(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* approveOrRejectFilesSaga(action) {
  try {
    const _api = yield call(approveOrRejectFileApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilesPendingApprovals(null));
      // yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);
  }
}

function* filterPendingApprovalsSaga(action) {
  try {
    const _api = yield call(filterFileApprovals, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setFilesPendingApprovals(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* watchFileApprovalSaga() {
  yield all([
    takeEvery(actionTypes.GET_FILE_PENDING_APPROVALS, getPendingApprovalSaga),
    takeEvery(actionTypes.APPROVE_OR_REJECT_FILES, approveOrRejectFilesSaga),
    takeEvery(actionTypes.GET_FILTERED_APPROVALS, filterPendingApprovalsSaga),
  ]);
}
